import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function LegalPage({ title, updated, testid, children }) {
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl mx-auto px-6 py-16" data-testid={testid}>
      <button onClick={() => navigate(-1)} data-testid="legal-back-button"
        className="flex items-center gap-2 text-white/50 hover:text-gold transition-colors mb-8 text-sm">
        <ArrowLeft className="w-4 h-4" /> Geri
      </button>
      <p className="text-sm uppercase tracking-[0.3em] text-gold mb-3">Yasal Bilgiler</p>
      <h1 className="font-serif text-4xl lg:text-5xl mb-2">{title}</h1>
      {updated && <p className="text-white/40 text-sm mb-10">Son güncelleme: {updated}</p>}
      <div className="space-y-4 text-white/70 leading-relaxed text-[15px] mt-8">
        {children}
      </div>
    </div>
  );
}

export function LegalH2({ children }) {
  return <h2 className="font-serif text-2xl text-white mt-10 mb-2">{children}</h2>;
}
